"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var lodash_1 = require("lodash");
var follow_modal_1 = require("./follow_modal");
var follow_button_1 = require("./follow_button");
var logged_out_follow_button_1 = require("./logged_out_follow_button");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var router_history_1 = require("@reverbdotcom/commons/dist/cms/lib/router_history");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
var follow_service_1 = require("./follow_service");
var bind_1 = require("../../../bind");
var location_util_1 = require("../../shared/location_util");
var constants_1 = require("../../shared/constants");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var FEED_HREF = '/my/feed';
var SINGLE_FOLLOW_PARAM = 1;
var TWO_FOLLOW_PARAMS = 2;
var FOLLOWING_SUBCATEGORY_WITH_NO_FILTERS = 3;
var FOLLOW_BUTTON = 'FollowButton';
var FOLLOW_BUTTON_IN_BANNER = 'FollowButtonInBanner';
var FollowButtonContainer = /** @class */ (function (_super) {
    tslib_1.__extends(FollowButtonContainer, _super);
    function FollowButtonContainer(props) {
        var _this = _super.call(this, props) || this;
        var modalOpen = !!props.followParams[constants_1.FOLLOW_PROMPT_PARAM];
        _this.state = {
            modalOpen: modalOpen,
            addGearAlert: true,
            usedOnly: false,
            priceMin: null,
            priceMax: null,
            loaded: false,
            filterByPrice: false,
        };
        return _this;
    }
    FollowButtonContainer.prototype.componentDidMount = function () {
        this.loadExistingFollowAndCount();
    };
    FollowButtonContainer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !lodash_1.isEqual(this.props, nextProps) || !lodash_1.isEqual(this.state, nextState);
    };
    FollowButtonContainer.prototype.componentDidUpdate = function (prevProps) {
        // Don't refetch follow if it's just internal state that's changed
        var notChanged = lodash_1.isEqual(prevProps, this.props);
        if (notChanged) {
            return;
        }
        this.loadExistingFollowAndCount();
        this.setState({ modalOpen: !!this.props.followParams[constants_1.FOLLOW_PROMPT_PARAM] });
    };
    FollowButtonContainer.prototype.loadExistingFollowAndCount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, findFollowResponse, queryParams, usedOnly, priceMax, priceMin, modalOpen, addGearAlert;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = this.buildParams();
                        return [4 /*yield*/, follow_service_1.default.fetch(params)];
                    case 1:
                        findFollowResponse = _a.sent();
                        queryParams = JSON.parse(findFollowResponse.query_params);
                        usedOnly = lodash_1.isEqual(queryParams.condition, [constants_1.USED_CONDITION]);
                        priceMax = queryParams.price_max;
                        priceMin = queryParams.price_min;
                        modalOpen = this.autoOpenForFollow(findFollowResponse);
                        addGearAlert = true;
                        if (findFollowResponse.following && !findFollowResponse.alert) {
                            addGearAlert = false;
                        }
                        this.setState({
                            findFollowResponse: findFollowResponse,
                            modalOpen: modalOpen,
                            addGearAlert: addGearAlert,
                            usedOnly: usedOnly,
                            priceMax: priceMax,
                            priceMin: priceMin,
                            loaded: true,
                            filterByPrice: !!(priceMin || priceMax),
                        });
                        tracker_1.trackView({
                            componentName: FOLLOW_BUTTON,
                            context: {
                                followable: !!lodash_1.get(findFollowResponse, '_links.self.href'),
                            },
                        });
                        if (this.props.renderWithBanner) {
                            tracker_1.trackView({
                                componentName: FOLLOW_BUTTON_IN_BANNER,
                                context: {
                                    followable: !!lodash_1.get(findFollowResponse, '_links.self.href'),
                                },
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FollowButtonContainer.prototype.autoOpenForFollow = function (follow) {
        if (!this.state.modalOpen || this.props.disabled) {
            return false;
        }
        return !!(follow && !follow.following && lodash_1.get(follow, '_links.self.href'));
    };
    FollowButtonContainer.prototype.handleSubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var paramsWithFormValues, findFollowResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.closeModal();
                        paramsWithFormValues = tslib_1.__assign(tslib_1.__assign({}, this.buildParams()), this.buildFormValues());
                        return [4 /*yield*/, follow_service_1.default.add(paramsWithFormValues)];
                    case 1:
                        findFollowResponse = _a.sent();
                        if (lodash_1.get(findFollowResponse, 'id')) {
                            mparticle_tracker_1.trackEvent({
                                eventName: mparticle_tracker_1.MParticleEventName.AddedFollow,
                                source: this.props.renderWithBanner ? FOLLOW_BUTTON_IN_BANNER : FOLLOW_BUTTON,
                                followId: findFollowResponse.id,
                                followType: this.getTranslationKey(),
                            });
                        }
                        this.setState({ findFollowResponse: findFollowResponse });
                        return [2 /*return*/];
                }
            });
        });
    };
    FollowButtonContainer.prototype.disabled = function () {
        if (this.props.disabled) {
            return true;
        }
        return !(this.state.loaded && lodash_1.get(this.state.findFollowResponse, '_links.self.href'));
    };
    FollowButtonContainer.prototype.buildFormValues = function () {
        var _a = this.state, priceMin = _a.priceMin, priceMax = _a.priceMax, usedOnly = _a.usedOnly, addGearAlert = _a.addGearAlert;
        var formValues = {
            price_min: priceMin,
            price_max: priceMax,
            digest_enabled: addGearAlert,
        };
        if (usedOnly) {
            formValues.condition = constants_1.USED_CONDITION;
        }
        return lodash_1.pickBy(formValues, lodash_1.identity);
    };
    FollowButtonContainer.prototype.buildParams = function () {
        var params = this.props.followParams || (tslib_1.__assign(tslib_1.__assign({}, this.props.location.query), this.props.routeParams));
        if (lodash_1.get(this.state, 'findFollowResponse.following')) {
            params.id = this.state.findFollowResponse.id;
        }
        return params;
    };
    FollowButtonContainer.prototype.closeModal = function () {
        var newParams = location_util_1.default.queryParams();
        if (!newParams[constants_1.FOLLOW_PROMPT_PARAM]) {
            this.setState({ modalOpen: false });
            return;
        }
        // Follow API always thinks queries with unknown params are followable.
        // Strip off this no-op param so we don't popup the modal on e.g. product type pages
        var updatedParams = lodash_1.omit(newParams, constants_1.FOLLOW_PROMPT_PARAM);
        router_history_1.default.replace({
            pathname: location_util_1.default.pathname(),
            query: updatedParams,
        });
    };
    FollowButtonContainer.prototype.openModal = function (trackerEventName) {
        if (this.disabled()) {
            return;
        }
        this.setState({ modalOpen: true });
        tracker_1.trackInteraction({ componentName: trackerEventName });
    };
    FollowButtonContainer.prototype.getTranslationKey = function () {
        var params = this.buildParams();
        var followParams = Object.keys(params).filter(function (k) { return !!params[k]; }); // avoid counting empty params
        if (followParams.includes('query'))
            return 'search';
        if (followParams.includes('product_type') &&
            followParams.includes('category') &&
            followParams.includes('id') &&
            followParams.length === FOLLOWING_SUBCATEGORY_WITH_NO_FILTERS)
            return 'category';
        if (followParams.includes('product_type') &&
            followParams.includes('category') &&
            followParams.length === TWO_FOLLOW_PARAMS)
            return 'category';
        if (followParams.length === SINGLE_FOLLOW_PARAM ||
            followParams.length === TWO_FOLLOW_PARAMS && followParams.includes('id')) {
            if (followParams.includes('product_type'))
                return 'category';
            if (followParams.includes('comparison_shopping_page_slug'))
                return 'product';
            if (followParams.includes('shop') ||
                followParams.includes('shop_id'))
                return 'shop';
            if (followParams.includes('curated_set_slug') ||
                followParams.includes('curated_set_id'))
                return 'collection';
            if (followParams.includes('brand_slug') ||
                followParams.includes('make'))
                return 'brand';
        }
        return 'search';
    };
    FollowButtonContainer.prototype.getFollowType = function () {
        return I18n.t("discovery.addFollowToFeed.followType." + this.getTranslationKey());
    };
    FollowButtonContainer.prototype.getBannerFollowType = function () {
        return I18n.t("discovery.addFollowToFeed.followBannerType." + this.getTranslationKey());
    };
    FollowButtonContainer.prototype.buttonText = function () {
        return I18n.t('discovery.addFollowToFeed.followThis', { type: this.getFollowType() });
    };
    FollowButtonContainer.prototype.headerLabel = function () {
        return (this.props.headerLabel ||
            I18n.t('discovery.addFollowToFeed.followModalTitle', { type: this.getFollowType().toLowerCase() }));
    };
    FollowButtonContainer.prototype.isFollowing = function () {
        return lodash_1.get(this.state, 'findFollowResponse.following', false);
    };
    FollowButtonContainer.prototype.followers = function () {
        return lodash_1.get(this.state, 'findFollowResponse.followers');
    };
    FollowButtonContainer.prototype.readableTitle = function () {
        return lodash_1.get(this.state, 'findFollowResponse.display');
    };
    FollowButtonContainer.prototype.hidden = function () {
        return lodash_1.get(this.state, 'findFollowResponse.hidden', false);
    };
    FollowButtonContainer.prototype.onModalUpdate = function (state) {
        var keys = ['usedOnly', 'addGearAlert', 'priceMin', 'priceMax', 'filterByPrice'];
        var providedState = {};
        keys.forEach(function (key) {
            if (state.hasOwnProperty(key)) {
                providedState[key] = state[key];
            }
        });
        if (state.filterByPrice === false) {
            providedState.priceMin = null;
            providedState.priceMax = null;
        }
        this.setState(providedState);
    };
    FollowButtonContainer.prototype.renderButton = function (trackerEventName) {
        if (this.props.user && this.props.user.loggedOut) {
            return (React.createElement(logged_out_follow_button_1.default, { addText: this.props.addText || this.buttonText(), unstyled: this.props.unstyled, followers: this.followers(), modalOpen: this.state.modalOpen, followParams: this.props.followParams, outlined: this.props.outlined, trackerEventName: trackerEventName }));
        }
        return (React.createElement(follow_button_1.default, { addText: this.props.addText || this.buttonText(), addedText: this.props.addedText, openModal: this.openModal, disabled: this.disabled(), isFollowing: this.isFollowing(), unstyled: this.props.unstyled, followers: this.followers(), disabledTooltipText: this.props.disabledTooltipText, followParams: this.props.followParams, outlined: this.props.outlined, trackerEventName: trackerEventName }));
    };
    FollowButtonContainer.prototype.renderModal = function () {
        if (this.props.user && this.props.user.loggedOut)
            return;
        return (React.createElement(follow_modal_1.default, { headerLabel: this.headerLabel(), isOpen: this.state.modalOpen, onUpdate: this.onModalUpdate, onRequestClose: this.closeModal, submit: this.handleSubmit, submitLabel: this.props.addText || I18n.t('discovery.addFollowToFeed.save'), withPriceFilters: this.props.withPriceFilters, withUsedFilter: this.props.withUsedFilter, addGearAlert: this.state.addGearAlert, usedOnly: this.state.usedOnly, filterByPrice: this.state.filterByPrice, priceMax: this.state.priceMax, priceMin: this.state.priceMin, readableTitle: this.readableTitle() }));
    };
    FollowButtonContainer.prototype.renderBannerOrButton = function () {
        if (!this.props.renderWithBanner)
            return this.renderButton(FOLLOW_BUTTON);
        if (this.props.renderWithBanner && this.disabled())
            return null;
        var params = Object.keys(this.buildParams());
        if (params.includes('id')) {
            return (React.createElement("div", { className: "feed-button__banner" },
                React.createElement("h4", { className: "size-150 mobile-size-130 weight-bold pb-half" },
                    React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.addFollowToFeed.youAreFollowingHtml', {
                            type: this.getBannerFollowType(),
                            spanOpen: '<span class="tt-capitalize">',
                            spanClose: '</span>',
                        }) })),
                React.createElement("p", { className: "size-90 mb-1" },
                    React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.addFollowToFeed.itemsMatchingHtml', {
                            linkOpen: "<a href=" + FEED_HREF + ">",
                            linkClose: '</a>',
                            type: this.getBannerFollowType(),
                        }) })),
                this.renderButton(FOLLOW_BUTTON_IN_BANNER)));
        }
        return (React.createElement("div", { className: "feed-button__banner" },
            React.createElement("h4", { className: "size-150 mobile-size-130 weight-bold pb-half" }, I18n.t('discovery.addFollowToFeed.letGearComeToYou')),
            React.createElement("p", { className: "size-90" },
                React.createElement(sanitized_render_1.default, { html: I18n.t('discovery.addFollowToFeed.followForFeedUpdatesHtml', {
                        type: this.getBannerFollowType(),
                        linkOpen: "<a href=" + FEED_HREF + ">",
                        linkClose: '</a>',
                    }) })),
            this.renderButton(FOLLOW_BUTTON_IN_BANNER)));
    };
    FollowButtonContainer.prototype.render = function () {
        if (this.hidden())
            return null;
        return (React.createElement("div", { className: "feed-button" },
            this.renderBannerOrButton(),
            this.renderModal()));
    };
    FollowButtonContainer.defaultProps = {
        location: {},
    };
    tslib_1.__decorate([
        bind_1.default
    ], FollowButtonContainer.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], FollowButtonContainer.prototype, "closeModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], FollowButtonContainer.prototype, "openModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], FollowButtonContainer.prototype, "onModalUpdate", null);
    return FollowButtonContainer;
}(React.Component));
exports.FollowButtonContainer = FollowButtonContainer;
exports.default = user_context_provider_1.withUserContext(FollowButtonContainer);
//# sourceMappingURL=follow_button_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/follow_button_container.js
// module id = H1lN
// module chunks = 20 21